// Arma el árbol de agrupamiento de un listado.
// levels: [{key, label, icon, value(item) -> {id, name} | null, emptyLabel}]
// Devuelve nodos {path, level, id, name, icon, items, children}; el último
// nivel no tiene children (sus items son las filas de la tabla).
export function buildTree(items, levels, depth, parentPath) {
  depth = depth || 0
  parentPath = parentPath || ''
  if(!levels.length || depth >= levels.length) return []

  var level = levels[depth]
  var groups = {}
  items.forEach(item => {
    var value = level.value(item)
    var id = value && value.id !== null && value.id !== undefined ? String(value.id) : '__empty'
    if(!groups[id]) {
      groups[id] = {
        path: parentPath + '/' + level.key + ':' + id,
        level: level,
        id: id,
        name: value ? value.name : (level.emptyLabel || 'Sin ' + level.label.toLowerCase()),
        image: value && value.image ? value.image : null,
        empty: id == '__empty',
        items: [],
      }
    }
    groups[id].items.push(item)
  })

  return Object.values(groups)
    // los "Sin ..." al final, el resto alfabético
    .sort((first, second) => (first.empty - second.empty) || String(first.name).localeCompare(String(second.name)))
    .map(node => {
      node.children = buildTree(node.items, levels, depth + 1, node.path)
      return node
    })
}

// items en el orden en que se ven en el árbol (para navegar prev/next)
export function flattenTree(nodes, items) {
  if(!nodes.length) return items || []
  var result = []
  nodes.forEach(node => {
    result = result.concat(node.children.length ? flattenTree(node.children) : node.items)
  })
  return result
}

// todos los paths del árbol (para "desplegar todo")
export function treePaths(nodes) {
  var result = []
  nodes.forEach(node => {
    result.push(node.path)
    result = result.concat(treePaths(node.children))
  })
  return result
}
